<template>
  <sweet-modal title="Edit Bank Account" blocking ref="modal" class="modal" v-on:close="close" width="700">
    <el-form :model="form" size="mini" ref="form" status-icon :rules="rules" label-position="left" label-width="200px">
      <el-tabs v-model="activeTab">
        <el-tab-pane name="first" label="Account">
          <el-form-item label="Account display name" prop="name">
            <div>
              {{form.name}}
            </div>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item label="Tax Code" prop="taxCode">
            <el-select v-model="form.taxCode" size="mini">
              <el-option v-for="item in salesTaxes"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Account Currency" prop="accountCurrency">
            <div>
              {{form.accountCurrency}}
            </div>
          </el-form-item>
          <el-form-item label="Opening Balance" prop="openingBalance">
            <div style="display: flex; align-items: center;">
              <div>
                {{formatPrice(form.openingBalance)}}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="Current Balance" prop="currentBalance">
            <div style="display: flex; align-items: center;">
              <div>
                {{formatPrice(form.currentBalance)}}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="Overdraft Limit" prop="overdraftLimit">
            <div style="display: flex; align-items: center;">
              <div>
                <money
                    v-model="form.overdraftLimit"
                    v-bind="money"
                    class="amount-input">
                </money>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="Allow Balancing Transactions" prop="allowBalancingTransaction">
            <el-checkbox v-model="form.allowBalancingTransaction"></el-checkbox>
          </el-form-item>
          <el-form-item label="Account Status" prop="accountStatus">
            <el-checkbox-group v-model="form.accountStatus">
              <el-checkbox label="Inactive"></el-checkbox>
              <el-checkbox label="Closed"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane name="second" label="Financial Institution">
          <el-card>
            <el-form-item label="Financial Institution" prop="financialInstitution">
              <el-input v-model="form.financialInstitution"></el-input>
            </el-form-item>
            <el-form-item label="Website" prop="website">
              <el-input placeholder="URL" v-model="form.website"></el-input>
            </el-form-item>
            <el-form-item label="Bank Account Type" prop="bankAccountType">
              <el-select
                  v-model="form.bankAccountType"
                  size="mini"
                  clearable>
                <el-option
                    v-for="item in bankAccountTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Bank Swift Code" prop="bankSwiftCode">
              <el-input v-model="form.bankSwiftCode"></el-input>
            </el-form-item>
            <el-form-item label="Bank Code" prop="bankCode">
              <el-input v-model="form.bankCode"></el-input>
            </el-form-item>
            <el-form-item label="Account Number" prop="accountNumber">
              <el-input v-model="form.accountNumber"></el-input>
            </el-form-item>
            <el-form-item label="IBAN" prop="IBAN">
              <el-input v-model="form.IBAN"></el-input>
            </el-form-item>
            <h3>Bank Manager</h3>
            <el-form-item label="Full Name" prop="bankManagerName">
              <el-row :span="24" :gutter="20" style="display: flex;">
                <el-col :span="12">
                  <el-input placeholder="Name" v-model="form.bankManagerName"></el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="Email" prop="bankManagerEmail">
              <el-input v-model="form.bankManagerEmail"></el-input>
            </el-form-item>
            <el-form-item label="Phone" prop="bankManagerPhone">
              <el-input v-model="form.bankManagerPhone"></el-input>
            </el-form-item>
            <el-form-item label="Fax" prop="BankManagerFax">
              <el-input v-model="form.BankManagerFax"></el-input>
            </el-form-item>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="third" label="Reconciliation">
          <el-form-item label="Reconcillation" prop="reconciliationDays">
            <el-row :span="24" :gutter="20" style="display: flex;">
              <el-col :span="12">
                <el-input placeholder="Every (Days)" type="number" v-model="form.reconciliationDays" ></el-input>
              </el-col>
              <el-col :span="12">
                <el-date-picker
                    v-model="form.reconcillationStartDate"
                    format="d MMM yy"
                    value-format="timestamp"
                    type="date"
                    placeholder="Start Date">
                </el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="Business Unit" prop="buId">
            <el-select
                v-model="form.buId"
                size="mini"
                placeholder="Business Unit"
                clearable
                @change="selectBu(form.buId)">
              <el-option
                  v-for="item in buList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="User" prop="buUserId">
            <el-select
                v-model="form.buUserId"
                size="mini"
                placeholder="User"
                clearable
                :disabled="!form.buId">
              <el-option
                  v-for="item in userList"
                  :key="item.companyUser.userId"
                  :label="item.companyUser.user.fullName"
                  :value="item.companyUser.userId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
      <el-form-item style="display: flex; justify-content: flex-end; margin-top: 20px;">
        <el-button size="large" @click="update('form')" type="primary">{{$t('general_save')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import { Money, VMoney } from 'v-money'
import axios from 'axios';
import moment from 'moment'

export default {
  name: "EditBankAccountModal",
  components: {
    SweetModal,
    Money
  },
  directives: {money: VMoney},
  data() {
    // const validateWebsite = (rule, value, callback) => {
    //   if (!value) {
    //     return callback();
    //   }
    //   setTimeout(() => {
    //     const pattern = /^((http|https|ftp):\/\/)/;
    //     if (!pattern.test(value)) {
    //       callback(new Error('Please input url'));
    //     } else {
    //       callback();
    //     }
    //   }, 1000);
    //
    // };
    return {
      salesTaxes: [],
      form: {
        // TODO added
        id: null,
        currentBalance: 0,
        overdraftLimit: 0,
        reconciliationDays: null,
        reconcillationStartDate: null,
        allowBalancingTransaction: false,
        financialInstitution: null,
        website: null,
        bankSwiftCode: null,
        IBAN: null,
        bankCode: null,
        accountNumber: null,
        bankManagerName: null,
        bankManagerEmail: null,
        bankManagerPhone: null,
        BankManagerFax: null,

        buId: null,
        buUserId: null,
        name: null,
        taxCode: null,
        accountCurrency: null,
        openingBalance: 0,
        accountStatus: [],
        bankAccountType: null,
        bankManagerLastName: null,
      },
      bankAccountTypeList: [],
      rules: {
        // financialInstitution: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // bankSwiftCode: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // IBAN: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // bankCode: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // accountNumber: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // reconciliationDays: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // buId: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ],
        // buUserId: [
        //   { required: true, message: 'Field is required', trigger: 'blur' }
        // ]
        // website: [
        //   {  validator: validateWebsite, trigger: 'blur' }
        // ]
      },
      money: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      activeTab: 'first',
      moment: moment,
      buList: [],
      userList: []
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    }
  },
  methods: {
    async openModal(row) {
      let loader = this.$loading.show();
      console.log('--row--', row)
      this.form.name = row.name
      this.form.id = row.id
      this.form.accountCurrency = row.currencyName
      this.form.accountStatus = []
      if (!row.active) {
        this.form.accountStatus.push('Inactive')
      }
      if (row.close) {
        this.form.accountStatus.push('Closed')
      }
      if (row.bankAccount) {
        this.form.currentBalance = row.bankAccount.currentBalance
        this.form.overdraftLimit = row.bankAccount.overDraftLimit
        this.form.reconciliationDays = row.bankAccount.reconciliationDays
        this.form.reconcillationStartDate = row.bankAccount.reconciliationStartDate ? moment(row.bankAccount.reconciliationStartDate).format('x') : null
        this.form.allowBalancingTransaction = row.bankAccount.allowBalancingTransaction
        this.form.financialInstitution = row.bankAccount.financialInstitution
        this.form.website = row.bankAccount.website
        this.form.bankAccountType = row.bankAccount.bankAccountTypeID
        this.form.bankSwiftCode = row.bankAccount.bankSwiftCode
        this.form.bankCode = row.bankAccount.bankCode
        this.form.accountNumber = row.bankAccount.accountNumber
        this.form.IBAN = row.bankAccount.IBAN
        this.form.bankManagerName = row.bankAccount.bankManagerName
        this.form.bankManagerLastName = row.bankAccount.bankManagerLastName
        this.form.bankManagerEmail = row.bankAccount.bankManagerEmail
        this.form.bankManagerPhone = row.bankAccount.bankManagerPhone
        this.form.BankManagerFax = row.bankAccount.BankManagerFax
        this.form.taxCode = row.bankAccount.taxCode && row.bankAccount.taxCode.id
        this.form.buId = row.bankAccount.buId
        this.form.buUserId = row.bankAccount.buUserId
      }
      const bakAccountTypes = await axios.get(`/api/v1/bankAccountType/list?companyId=${this.$route.query.companyId}`)
      this.bankAccountTypeList = bakAccountTypes.data.list
      const response = await axios.post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
      if (this.form.buUserId) {
        const response2 = await axios.post(`/api/v1/businessUnitUsers/list?companyId=${this.$route.query.companyId}&businessUnitId=${this.form.buId}`)
        this.userList = response2.data.list
      }
      this.buList = response.data.list
      loader.hide()
      // TODO what to set here
      this.$refs.modal.open()

      const { data } = await axios.get(`/api/v1/tax/get?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}&taxTopType=sale`)
      this.salesTaxes = data.result
    },
    update(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const payload = {
            currentBalance: this.form.currentBalance,
            overdraftLimit: this.form.overdraftLimit,
            reconciliationDays: this.form.reconciliationDays ? this.form.reconciliationDays : null,
            reconciliationStartDate: this.form.reconcillationStartDate ? this.form.reconcillationStartDate : null,
            allowBalancingTransaction: this.form.allowBalancingTransaction,
            financialInstitution: this.form.financialInstitution,
            taxCode: this.form.taxCode,
            website: this.form.website,
            bankSwiftCode: this.form.bankSwiftCode,
            IBAN: this.form.IBAN,
            bankCode: this.form.bankCode,
            accountNumber: this.form.accountNumber,
            bankManagerName: this.form.bankManagerName,
            bankAccountTypeID: this.form.bankAccountType,
            // bankManagerLastName: this.form.bankManagerLastName,
            bankManagerEmail: this.form.bankManagerEmail,
            bankManagerPhone: this.form.bankManagerPhone,
            BankManagerFax: this.form.BankManagerFax,
            buId:  this.form.buId ? this.form.buId : null,
            buUserId: this.form.buUserId ? this.form.buUserId : null,
            inactive: this.form.accountStatus.includes('Inactive'),
            close: this.form.accountStatus.includes('Closed')
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/bankAccount/update?accountId=${this.form.id}`, payload).then(data => {
            this.$emit('loadList')
            this.$refs.modal.close()
          }).catch(error => {
            this.$notify({
              title: 'Notification',
              message: error.response.data.message,
              type: 'info'
            })
          })
        }
      })
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async selectBu(buId) {
      this.form.buUserId = null
      this.userList = []
      if (buId) {
        let loader = this.$loading.show();
        const response = await axios.post(`/api/v1/businessUnitUsers/list?companyId=${this.$route.query.companyId}&businessUnitId=${buId}`)
        console.log(',,,', response.data.list)
        this.userList = response.data.list
        loader.hide()
      }
    },
    close() {
      this.form.id = null
      this.form.name = ''
      this.form.taxCode = null
      this.form.accountCurrency = null
      this.form.openingBalance = 0
      this.form.currentBalance = 0
      this.form.reconciliationDays = null
      this.form.reconcillationStartDate = null
      this.form.allowBalancingTransaction = false
      this.form.accountStatus = []
      this.form.financialInstitution = null
      this.form.website = null
      this.form.bankAccountType = null
      this.form.bankSwiftCode = null
      this.form.bankCode = null
      this.form.accountNumber = null
      this.form.IBAN = null
      this.form.bankManagerName = null
      this.form.bankManagerLastName = null
      this.form.bankManagerEmail = null
      this.form.bankManagerPhone = null
      this.form.BankManagerFax = null
      this.form.buId = null
      this.form.buUserId = null
      this.buList = []
      this.userList = []
      this.activeTab = 'first'
      this.$refs['form'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.amount-input {
  display: block;
  resize: vertical;
  padding: 0 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200px;
  font-size: inherit;
  color: #606266;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  height: 33px;
  &:focus {
    outline: 0;
    border-color: #409EFF;
  }
  &.readonly {
    background: rgba(201, 202, 205, 0.5);
  }
}
</style>
